import React from "react";
import { useNavigate , Link} from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-busuness-01.jpg";
import cons01 from "../../assets/img/consulting-01.jpg";
import cons02 from "../../assets/img/consulting-02.jpg";
import cons03 from "../../assets/img/consulting-03.jpg";
import cons04 from "../../assets/img/consulting-04.jpg";
import CallWipia from "./CallWipia";

function ITConsulting() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';

    return (<>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
						<h2>IT Consulting</h2>
						<p>위피아는 고객의 Needs에 부합하는 e-Business 시스템을 구축합니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="container-auto sec-my bs-consulting-wrap">
					<ul className="consulting-list">
						{/* <!-- Item 01 --> */}
						<li>
							<img src={cons01} alt="Experience" />

							<div className="textBox">
								<h4 className="title"><span className="num">01</span> Experience</h4>
								<p className="text">축적된 경험을 통해 최적의 컨설팅을 제공합니다.</p>
							</div>
						</li>

						{/* <!-- Item 02 --> */}
						<li>

							<img src={cons02} alt="Knowhow" />
							<div className="textBox">
								<h4 className="title"><span className="num">02</span> Knowhow</h4>
								<p className="text">프로젝트 수행과정에서 생긴 노하우로 최적의 컨설팅을 제안합니다.</p>
							</div>
						</li>

						{/* <!-- Item 03 --> */}
						<li>
							<img src={cons03} alt="Professional" />

							<div className="textBox">
								<h4 className="title"><span className="num">03</span> Professional</h4>
								<p className="text">전문적인 인력과 솔루션으로 현재와 미래의 요건을 충족하는 IT 컨설팅이 되기 위해 노력합니다.</p>
							</div>
						</li>

						{/* <!-- Item 04 --> */}
						<li>

							<img src={cons04} alt="Needs" />
							<div className="textBox">
								<h4 className="title"><span className="num">04</span> Needs</h4>
								<p className="text">고객이 원하는 형태의 업무 시스템 구축, 유지보수 및 아웃소싱등 다양한 상황을 반영하는 컨설팅을 제공합니다.</p>
							</div>
						</li>

					</ul>
			</section>

			<CallWipia />
				
		</main>
	<Footer />

        </>
    )
}

export default ITConsulting;